import React, { useCallback } from 'react';
import TryItOutHighRiskWarningDialog from '@modules/openCloud/swagger/components/TryItOutHighRiskWarningDialog';
import { logTryItOutEvent } from '@modules/openCloud/swagger/components/tryItOut';
import DocsSiteEventType from '@modules/eventStream/enum/DocsSiteEventType';
import useTryItOut from '../../hooks/useTryItOut';
import useOperation from '../../hooks/useOperation';

export interface TryItOutExecutionWarningDialogComponentProps {
  executionWarningOpen: boolean;
  setExecutionWarningOpen: (open: boolean) => void;
  onContinue: () => void;
}

const TryItOutExecutionWarningDialog: React.FC<TryItOutExecutionWarningDialogComponentProps> = ({
  executionWarningOpen,
  setExecutionWarningOpen,
  onContinue,
}) => {
  const { authMode, setExecutionWarningAccepted } = useTryItOut();
  const { method, url, riskLevel } = useOperation();

  const handleClose = useCallback(() => {
    logTryItOutEvent(DocsSiteEventType.TryItOutClickCancelHighRiskWarning, {
      method: method.toUpperCase(),
      url,
      riskLevel,
      authMode,
    });
    setExecutionWarningOpen(false);
  }, [method, url, riskLevel, authMode, setExecutionWarningOpen]);

  const handleContinue = useCallback(() => {
    logTryItOutEvent(DocsSiteEventType.TryItOutClickAcceptHighRiskWarning, {
      method: method.toUpperCase(),
      url,
      riskLevel,
      authMode,
    });
    setExecutionWarningAccepted(true);
    setExecutionWarningOpen(false);
    onContinue();
  }, [
    method,
    url,
    riskLevel,
    authMode,
    setExecutionWarningAccepted,
    setExecutionWarningOpen,
    onContinue,
  ]);

  return (
    <TryItOutHighRiskWarningDialog
      open={executionWarningOpen}
      onClose={handleClose}
      onContinue={handleContinue}
    />
  );
};

export default TryItOutExecutionWarningDialog;
